export const combineCityState = (city, stateOrCountry) => {
  if (!city && !stateOrCountry) return '';
  if (city && stateOrCountry) {
    return `${city}, ${stateOrCountry}`;
  }
  return city || stateOrCountry;
};

export const buildChildStatus = child => {
  const statusParts = [];
  if (child?.relationship) {
    statusParts.push(child.relationship);
  }
  if (child?.inSchool) {
    statusParts.push('18-23_YEARS_OLD');
  }
  if (child?.seriouslyDisabled) {
    statusParts.push('SERIOUSLY_DISABLED');
  }
  if (child?.hasBeenMarried) {
    statusParts.push('CHILD_PREVIOUSLY_MARRIED');
  }
  if (child?.nonChildLivesWith === false || child?.childLivesWith === 'NO') {
    statusParts.push('DOES_NOT_LIVE_WITH_SPOUSE');
  }

  return statusParts;
};

export const buildAddress = unitAddress => {
  const { street, street2, city, state, postalCode } = unitAddress;
  let address = street || '';
  if (street2) {
    address += `, ${street2}`;
  }
  if (city) {
    address += `, ${city}`;
  }
  if (state) {
    address += `, ${state}`;
  }
  if (postalCode) {
    if (!state) {
      address += `, ${postalCode}`;
    } else {
      address += ` ${postalCode}`;
    }
  }
  return address;
};
